import { useState, useEffect } from 'react';
import axios from 'axios';
import { BIOMETRIC_DEVICE_INFO,  GET_AEPS_DEVICE_CONFIG, FING_PAY_2FA_BIOMETRIC_REQUEST, FING_PAY_BANK_LIST, FING_PAY_CHECK_EKYC_STATUS, POST_AEPS_LOGIN_STATUS /* BIOMETRIC_CAPTURE_API, BIOMETRIC_CAPTURE_XML_DATA */ } from '../../Utils/appConstants';
// import { getUser } from '../../Utils/Common';
import { useHistory } from "react-router-dom";
import { getGeoLocation } from '../../Utils/function';
// import { ToastContainer } from 'react-toastify';
import xmlJs from 'xml-js';
import SettelTOBank from '../moveToBank/index';
import BankSetting from '../banksetting';
import { postRequest, getRequest } from '../../Utils/AppApi';
import CashWithdrawal from './CashWithdrawal';
import BioDevice from '../aepsInstant/bioDevice';
import BioDeviceList from '../aepsInstant/bioDeviceList';
import BalanceEnquiry from './BalanceEnquiry';
import MiniStatement from './MiniStatement';
import AadharPayHistory from '../aepsInstant/AadharPayHistory';
import AePSRegister from './AePSRegister';
import { toast } from 'react-toastify';
import { Tabs, Modal, Checkbox } from 'antd';
import { reactLocalStorage } from 'reactjs-localstorage';
import moment from "moment";
const { TabPane } = Tabs;

const MyComponent = () => {
    const history = useHistory();
    // const user = getUser();
    const [isConsent, setConsent] = useState(false);
    // const LoginStatusDate = reactLocalStorage.get("LoginStatusDate");
    const tabPosition = 'left';
    const [fingerprint, setFingerprint] = useState(null)
    // const [fingerprintModal, setFingerprintModal] = useState(null)
    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");
    const [getBankList, setBankList] = useState([]);
    const [deviceConfig, setDeviceConfig] = useState({});
    const [isAuthAePSModel, setAuthAePSModel] = useState(false);
    const [isErrorAuth, setErrorAuth] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [subTabs, setSubTabs] = useState('1');
    const [getDataField, setDataField] = useState([]);
    const [modal, contextHolder] = Modal.useModal();
    const [isDeviceConnected, setIsDeviceConnected] = useState(false);

    const detectFingerprintDevice = async () => {
        try {
            
            const res = await axios({
                method: 'DEVICEINFO', url: deviceConfig.infoUrl,
                headers: { "Content-Type": "text/xml; charset=UTF-8", }, data: ` `
            });

            const jsonData = xmlJs.xml2json(res.data, { compact: true });
            const parsed = JSON.parse(jsonData);

            const params = parsed?.DeviceInfo?.additional_info?.Param;

            let srnoValue = null;

            if (Array.isArray(params)) {
                const srnoParam = params.find(p => p._attributes?.name === "srno");
                srnoValue = srnoParam?._attributes?.value;
            } else if (params?._attributes?.name === "srno") {
                srnoValue = params._attributes?.value;
            }

            const isConnected = !!srnoValue && srnoValue.trim() !== "";

            return isConnected;
        } catch (err) {
            return false;
        }
    };

    // useEffect(() => {
    // const interval = setInterval(async () => {
    // // const status = await detectFingerprintDevice();
    // // setIsDeviceConnected(status);
    // }, 5000);

    // return () => clearInterval(interval);
    // }, []);

    // useEffect(() => {
    // let intervalId = null;

    // const pollDevice = async () => {
    // const status = await detectFingerprintDevice();

    // setIsDeviceConnected(prev => {
    // // Device disconnected → resume polling
    // if (prev && !status) {
    // startPolling();
    // }
    // return status;
    // });
    // };

    // const startPolling = () => {
    // if (!intervalId) {
    // intervalId = setInterval(pollDevice, 3000);
    // }
    // };

    // const stopPolling = () => {
    // if (intervalId) {
    // clearInterval(intervalId);
    // intervalId = null;
    // }
    // };

    // // Initial polling
    // startPolling();

    // // Watch connection state
    // if (isDeviceConnected) {
    // stopPolling(); // stop when connected
    // } else {
    // startPolling(); // resume when disconnected
    // }

    // return () => {
    // stopPolling();
    // };
    // }, [isDeviceConnected]);

    // const [accessAeps, setAccessAeps] = useState(false);

    const countDown = () => {
        let secondsToGo = 10;
        const instance = modal.success({
            title: <><h3>Your aeps service service activation is under process. please wait a same time.</h3></>,
            // content: This modal will be destroyed after ${secondsToGo} second.,
            width: "600px",
            okText: "",
        });
        const timer = setInterval(() => {
            secondsToGo -= 1;
            // instance.update({
            // title: <><h3>Your aeps service activation is under process. please wait a same time.</h3></>,
            // // content: This modal will be destroyed after ${secondsToGo} second.,
            // okText: ""
            // });
        }, 1000);
        setTimeout(() => {
            clearInterval(timer);
            instance.destroy();
            history.push({ pathname: "/dashboard" });
        }, secondsToGo * 1000);
    };

    const fetchLocation = async () => {
        let data = await getGeoLocation();
        setLatitude(data.latitude);
        setLongitude(data.longitude);
    }
    useEffect(() => {
        ekyChackApproved();
        aepsLoginStatus();
        getBankListData();
        aepsConfig();
        fetchLocation();
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (fingerprint) {
            // let data = biometricDataToJson(fingerprint)
            aepsLogin(fingerprint)
        }
    }, [fingerprint]) // eslint-disable-line react-hooks/exhaustive-deps

    const existInputData = (event, select) => {
        if (select) {
            setDataField({ ...getDataField, "bankiin": select });
        } else {
            const { name, value } = event.target ? event.target : event;
            // console.log("------existInputData--------------",name, value)
            // let aepsInputValue = reactLocalStorage.get("aepsInputValue");
            // reactLocalStorage.set("aepsInputValue", JSON.stringify(getDataField));
            setDataField({ ...getDataField, [name]: value });
        }
    }

    const clearExistInputData = () => {
        window.location.reload()
        // console.log("------response--------------")
        setDataField({});
    }

    const aepsConfig = () => {
        getRequest(GET_AEPS_DEVICE_CONFIG, history).then((response) => {
            if (response.success === true) {
                // console.log("------response--------------", response)
                setDeviceConfig(response.data)
                reactLocalStorage.set("aepsConfig", JSON.stringify(response.data));
                // toast.success(response.message);
            } else {
                setAuthAePSModel(true)
                setErrorAuth(false)
                setErrorMessage(response.message)
            }
        })
    }

    const ekyChackApproved = () => {
        getRequest(FING_PAY_CHECK_EKYC_STATUS, history).then((response) => {
            if (response.success === true) {
                if (!response.data.isCompleted) {
                    countDown();
                }
            } else {
                countDown();
            }
        })
    }

     const getBankListData = async () => {
        await getRequest(FING_PAY_BANK_LIST, history)
            .then((response) => {
                if (response.success === true) {
                    // Filter banks where aadharPay equals 'Y' (case‑insensitive)
                    const filteredBanks = response.data.filter(
                        (item) => item.aadharPay && item.aadharPay.toUpperCase() === 'Y'
                    );

                    setBankList(
                        filteredBanks.map((item) => ({
                            value: item.iinno,
                            label: item.bankName,
                        }))
                    );
                } else {
                    toast.error(response.message);
                }
            })
            .catch(function (error) {
                console.log(error);
                // setLoading(false);
            });
    };

    const aepsLogin = (data) => {
        const payload = {
            devicetype: "W",
            latitude: latitude,
            longitude: longitude,
            isXml: true,
            biometricData: data,
            serviceType:"AP"
        }

        postRequest(FING_PAY_2FA_BIOMETRIC_REQUEST, payload, history).then((response) => {
            if (response.success === true) {
                // console.log("------response--------------", response)
                // reactLocalStorage.set("LoginStatusDate", moment().format('DD-MM-YYYY'));
                setAuthAePSModel(false)
                // toast.success(response.message);
            } else {
                // console.log("------response--------------", response)

                if (response.rekyc) {
                    history.push({ pathname: "/partner-ekyc" })
                }
                setAuthAePSModel(true)
                toast.error(response.message);
            }
        })
    }

    const aepsLoginStatus = () => {
        // if (LoginStatusDate !== moment().format('DD-MM-YYYY')) {
        // setAuthAePSModel(true)
        // }
        let payload = { date: moment().format('YYYY-MM-DD'), key: "AEPS_FINGPAY" }
        postRequest(POST_AEPS_LOGIN_STATUS, payload, history).then((response) => {
            if (response.success === true) {
                // console.log("------response--------------", response)
                // toast.success(response.message);
                // if (LoginStatusDate !== moment().format('DD-MM-YYYY')) {
                setAuthAePSModel(false)
                // }
            } else {
                setAuthAePSModel(true)
                // setErrorAuth(false)
                // setErrorMessage(response.message)
            }
        })
    }


    const scanFingerPrintData = async () => {
    const status = await detectFingerprintDevice();
    setIsDeviceConnected(status);
    if (!status) {
        toast.error("device not connected, check connection and try again");
        setConsent(false);
        return;
    }
    await axios({
        method: 'CAPTURE',
        url: deviceConfig.captureUrl,
        // url: "http://127.0.0.1:11100/rd/capture",
        headers: {
            "Content-Type": "text/xml; charset=UTF-8",
        },
        // data: '<PidOptions ver="1.0"><Opts fCount="1" fType="2" iCount="0" iType="0" pCount="0" format="0" pidVer="2.0" timeout="10000" posh="UNKNOWN" env="P" wadh=""/></PidOptions>'
        data: deviceConfig.xmlData
    }).then(response => {
        const jsonData = xmlJs.xml2json(response.data, { compact: true, spaces: 4 });
        let XMLjson = JSON.parse(jsonData);
        console.log("response---------------------------", response)
        // Check the string length of jsonData (parsed JSON object has no .length)
        if (jsonData.length < 1500) {
            scanFingerPrintData();
            return;
        }
        // Check for proper success (errCode === "0") before setting data
        if (XMLjson && XMLjson.PidData?.Resp?._attributes?.errCode === "0") {
            setFingerprint(response.data)
        } else {
            setFingerprint(null)
        }
    }).catch(error => {
        console.log("err---------------------------", error)
    })
};

    
    useEffect(() => {
        // your aeps service activation is under process. please wait a same time.
        ekyChackApproved();
    }, [subTabs]) // eslint-disable-line react-hooks/exhaustive-deps

    const subChangeTab = (activeKey) => {
        setSubTabs(activeKey)
        // setFingerprintModal(null)
    }

    const handleCloseModal = () => {
        setAuthAePSModel(false)
    }

  

    const items = [
        {
            key: '1',
            label: 'Aadhaar Pay',
            children: <CashWithdrawal deviceConfig={deviceConfig} getBankList={getBankList} subChangeTab={subChangeTab} existInputData={existInputData} existData={getDataField} clearExistInputData={clearExistInputData} />,
        },
        // {
        //     key: '2',
        //     label: 'Balance Enquiry',
        //     children: <BalanceEnquiry deviceConfig={deviceConfig} getBankList={getBankList} subChangeTab={subChangeTab} existInputData={existInputData} existData={getDataField} clearExistInputData={clearExistInputData} />,
        // },
        // {
        //     key: '3',
        //     label: 'Mini Statement',
        //     children: <MiniStatement deviceConfig={deviceConfig} getBankList={getBankList} subChangeTab={subChangeTab} existInputData={existInputData} existData={getDataField} clearExistInputData={clearExistInputData} />,
        // },
        {
            key: '4',
            label: 'Aadhaar Pay History',
            children: <AadharPayHistory />,
        },
    ];

    const onChangeChackBox = async (e) => {
        const newChecked = e.target.checked;
        if (newChecked) {
            const status = await detectFingerprintDevice();
            setIsDeviceConnected(status);
            if (!status) {
                toast.error("Fingerprint Scanner device not connected, Check connection and try again");
                return;
            }
        }
        setConsent(newChecked);
    };

    return (
        <div>
            <div className="content-wrapper pt-2">
                <div className="content">
                    {contextHolder}
                    <div className="container-fluid pt-2 pb-5">
                        <div className="row">
                            <div className="col-md-12">
                                <div className='card rounded-0 card-body'>
                                    <Tabs defaultActiveKey="1" tabPosition={tabPosition}>
                                        <TabPane tab={"Transact"} key={1}>
                                            {/* <div className="col-12 text-right">
                                                <strong className='text-right text-danger fa-xl'>Powered By NSDL</strong>
                                            </div> */}

                                            <div className="col-12 text-right">
                                                <strong className="text-danger fa-xl me-3">
                                                    Powered By NSDL
                                                </strong>

                                                <button
                                                    className="btn btn-primary rounded-pill pl-4 pr-4 ml-3"
                                                    onClick={() => setAuthAePSModel(true)}
                                                >
                                                    Re-login
                                                </button>


                                            </div>

                                            <Tabs defaultActiveKey={'1'} activeKey={subTabs} tabPosition={'top'} items={items} type="card" onChange={subChangeTab}>
                                                {/* <TabPane tab={"Cash Withdrawal"} key={1}>
                                                    { subTabs === '1' && <CashWithdrawal getBankList={getBankList} subChangeTab={subChangeTab} />}
                                                </TabPane>
                                                <TabPane tab={"Balance Enquiry"} key={2}>
                                                    { subTabs === '2' && <BalanceEnquiry getBankList={getBankList} subChangeTab={subChangeTab} />}
                                                </TabPane>
                                                <TabPane tab={"Mini Statement"} key={3}>
                                                    { subTabs === '3' && <MiniStatement getBankList={getBankList} subChangeTab={subChangeTab} />}
                                                </TabPane>
                                                <TabPane tab={"AePS History"} key={4}>
                                                </TabPane> */}
                                            </Tabs>
                                        </TabPane>
                                        <TabPane tab={"Settel To Bank"} key={2}>
                                            <SettelTOBank />
                                        </TabPane>
                                        <TabPane tab={"Device Setting"} key={3}>
                                            {/* <CashWithdrawal /> */}
                                        </TabPane>
                                        <TabPane tab={"Bank Setting"} key={4}>
                                            <BankSetting />
                                        </TabPane>
                                        <TabPane tab={"Biometric Devices"} key={5}>
                                            <BioDeviceList />
                                        </TabPane>
                                        <TabPane tab={"AePS Register"} key={6}>
                                            <AePSRegister />
                                        </TabPane>
                                    </Tabs>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <ToastContainer position="top-center" autoClose={5000} limit={2} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="colored" /> */}
                {isAuthAePSModel && <Modal title={"AePS Verification Secure Login"} width={600} open={isAuthAePSModel} onCancel={() => handleCloseModal()} footer={false} >
                    {isErrorAuth ?
                        <div><p className='text-danger'>{errorMessage && errorMessage.replace('please try again later', 'Please wait until Bank approval')}</p>
                        </div>
                        :
                        <>
                            <div className='text-center h-100'>
                                <img src={'./../fingerprint-svgrepo-com.svg'} alt='' width={'175px'} />
                            </div>
                            <div className='col-sm-12 col-md-12 col-lg-12 mb-120'>
                                <div className='form-group'>
                                    <Checkbox className='d-flex' checked={isConsent} onChange={onChangeChackBox}>I hereby give my voluntary consent to SR PAY Private Limited, use my Aadhaar/ VID number & biometric to authenticate from UIDAI for the purpose of AEPS transaction.</Checkbox>
                                </div>
                            </div>
                            <BioDevice />
                            {/* <button className='btn btn-primary btn-lg bg-primary btn-block' onClick={() => scanFingerPrintData()}>Scan Finger</button>} */}
                            <button
                                className="btn btn-primary btn-lg bg-primary btn-block"
                                onClick={scanFingerPrintData}
                                disabled={!isConsent || !isDeviceConnected}
                            >
                                Scan Finger
                            </button>
                        </>
                    }
                    <div className="text-center mb-2">
                        {isDeviceConnected ? (
                            <span className="text-success fw-bold">
                                🟢 Fingerprint Device Connected
                            </span>
                        ) : (
                            <span className="text-danger fw-bold">

                            </span>
                        )}
                    </div>
                </Modal>}
            </div>
        </div>
    )
}
export default MyComponent;